import { includes } from 'lodash';
import useProductList from '../../../../../../hooks/queries/product/useProductList';
import { GetProductListRequest } from '../../../../../../lib/api/product/type';
import { setDateFormat } from '../../../../../../lib/moment';
import { TableOption } from '../types';
import { ProductItem } from '../../../types';
import { ProductsResponseBodyDto } from '../../../../../../types/api/products';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import { PRODUCT_STATUS_V2 } from '../../../../../../types/product';
import { BRAND_STATUS_V2 } from '../../../../../../types/brand/common';
import { checkValidId } from '../../../../../../lib/utils/common/checkValideId';

const convertRequest = (option: TableOption): GetProductListRequest => {
  const { filterOption, pagination } = option;
  return {
    id: filterOption.id,
    name: filterOption.name,
    brandId: filterOption.brandId,
    brandName: filterOption.brandName,
    page: pagination.pageNum + 1,
    pageSize: pagination.pageSize,
    status: PRODUCT_STATUS_V2.NOW_ON_SALE,
    brandStatus: BRAND_STATUS_V2.ACTIVE,
    sort: ['-id'],
  };
};

const convertResponse = (data: ProductsResponseBodyDto, selectedProductIdList: number[]) => {
  const { totalCount, products } = data;

  return {
    totalCount,
    productList: products.map((item) => ({
      id: item.id,
      name: item.name,
      originPrice: item.originPrice,
      salesPrice: item.salesPrice,
      discountPeriod:
        item.discountStartDate && item.discountEndDate
          ? `${setDateFormat(item.discountStartDate, DATE_FORMAT.FULL_DASH_FORMAT)} -\n ${setDateFormat(
              item.discountEndDate,
              DATE_FORMAT.FULL_DASH_FORMAT,
            )}`
          : '-',
      createDate: setDateFormat(item.createDate, DATE_FORMAT.FULL_DASH_FORMAT),
      status: item.status,
      discountPrice: item.discountPrice || null,
      discountRate: item.discountRate || null,
      imageUrl: item.mainImageUrl,
      category: item.mainCategories.reduce((previousValue, currentValue) => {
        if (previousValue === '') return currentValue.name;
        return `${previousValue}, ${currentValue.name}`;
      }, ''),
      brandId: item.brand.id,
      brandName: item.brand.name,
      uncheckable: includes(selectedProductIdList, item.id),
    })),
  };
};

type UseProductListData = {
  totalCount: number;
  productList: ProductItem[];
};
interface UseProductListModal {
  data?: UseProductListData;
}
const useProductListModal = (option: TableOption, selectedProductIdList: number[]): UseProductListModal => {
  const isValidId = checkValidId([option.filterOption.id, option.filterOption.brandId]);

  const { data } = useProductList<UseProductListData>({
    payload: convertRequest(option),
    options: {
      select: (data) => convertResponse(data, selectedProductIdList),
      placeholderData: {
        totalCount: 0,
        products: [],
      },
      enabled: isValidId,
      keepPreviousData: true,
    },
  });

  return {
    // 유효하지 않은 ID일 경우, API 호출 결과 대신 빈 데이터 객체를 반환
    data: isValidId ? data : { totalCount: 0, productList: [] },
  };
};

export default useProductListModal;
